const Features = () => {
    return (
        <section className="section features" aria-labelledby="features-label" id="features">
            <div className="container">
                <h3 className="h3 section-title">
                    Key Features
                </h3>

                <p className="section-subtitle">Built for advisors. Backed by service. Designed to make your day easier.</p>

                <ul className="grid-list">
                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="apps-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title"> Intuitive Client Management</h5>
                            <p className="card-text">
                                Securely store and organize all essential client information in one easy-to-navigate 
                                platform—built for speed, clarity, and efficiency.
                            </p>
                        </div> 
                    </li>

                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="create-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title">One-Click Form Filling</h5>
                            <p className="card-text">
                                 Prefill ACATs, new account paperwork, and compliance forms with a single click using stored 
                                 client data—no more repetitive entry.
                            </p>
                        </div> 
                    </li>

                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="documents-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title">Document Bundles Made Easy</h5>
                            <p className="card-text">
                                 Generate complete document packages instantly, helping you move faster through onboarding 
                                 and compliance processes.
                            </p>
                        </div> 
                    </li>

                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="people-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title">Household Linking</h5>
                            <p className="card-text">
                                Link related accounts and individuals to keep family-level data connected and easy to manage.
                            </p>
                        </div> 
                    </li>

                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="cloud-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title">Data Ownership & Access</h5>
                            <p className="card-text">
                                Your data is always your own. Download it anytime in Excel format—no restrictions, no red tape.
                            </p>
                        </div> 
                    </li>

                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="key-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title">Role-Based Access Controls</h5>
                            <p className="card-text">
                                Set permissions by team member to protect sensitive data and ensure the right access at every level.
                            </p>
                        </div> 
                    </li>

                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="lock-closed-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title">Built-In Security</h5>
                            <p className="card-text">
                                With two-factor authentication and enterprise-grade security protocols, your client data stays safe and protected.
                            </p>
                        </div> 
                    </li>

                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="person-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title">Real Human Support</h5>
                            <p className="card-text">
                                From live onboarding to ongoing chat support and a searchable knowledge base, help is always within reach.
                            </p>
                        </div> 
                    </li>

                    <li>
                        <div className="features-card">
                            <div className="card-icon">
                                <ion-icon name="trending-up-outline" aria-hidden="true"></ion-icon>
                            </div>

                            <h5 className="h5 card-title">Scales with You</h5>
                            <p className="card-text">
                                Whether you're a solo advisor, a broker-dealer, or an enterprise RIA, Advisors Reserve is 
                                designed to grow with your business.
                            </p>
                        </div> 
                    </li>
                </ul>
            </div>
        </section>
    )
}

export default Features